<template>
  <div>
    <table class="table">
      <tr v-for="(batch, index) in data.batches" :key="index">
        <td>
          <label>Select Batch Number</label>
          <select
            class="form-control"
            v-model="batch.Id"
            @change="getSingleBatchDetail(batch.Id, batch)"
            required
          >
            <option disabled>-------- Select Batch --------</option>
            <option
              v-for="(itemBatch, index) in ItemBatches"
              :key="index"
              :value="itemBatch.Id"
            >
             {{ itemBatch.BatchNumber }} {{ index == 0 ? " - FIFO " : ""  }}
            </option>
          </select>
        </td>
        <td>
          <label>Issued Quantity</label>
          <input
            type="text"
            class="form-control"
            placeholder="Quantity"
            v-model="batch.IssuedQuantity"
            required
          />
        </td>

        <td>
          <label>Available Quantity</label>
          <input
            type="text"
            class="form-control"
            placeholder="Quantity"
            readonly
            v-model="batch.AvailableQuantity"
            required
          />
        </td>

        <!--    <td>
                <label>MFGDate</label>
                <input
                type="date"
                class="form-control"
                placeholder="MFG"
                readonly
                v-model="batch.MFGDate" />
              </td> -->
        <td>
          <label>Expiry Date</label>
          <input
            type="date"
            class="form-control"
            placeholder="Expiry"
            readonly
            v-model="batch.ExpiryDate"
          />
        </td>
        <td>
          <div class="text-right">
            <button
              class="btn btn-sm btn-danger mt-3 btn-add-new-batch"
              data-toggle="tooltip"
              data-placement="top"
              title="Remove batch"
              @click="removeRow(index)"
            >
              <i class="fas fa-trash-alt"></i>
            </button>
          </div>
        </td>
      </tr>
      <tr>
        <td colspan="5">
          <div class="text-right">
            <span
              class="btn btn-sm btn-info mt-3 btn-add-new-batch text-white"
              data-toggle="tooltip"
              data-placement="top"
              title="Add new Batch"
              v-on:click="addNewBatchRow(ItemId)"
            >
              <i class="fa fa-plus-circle"></i>
            </span>
          </div>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  name: "delivery-challan-item-batch",
  props: ["ItemId", "ItemBatches"],
  data() {
    return {
      data: {
        ItemId: this.ItemId,
        batches: [
          {
            Id: null,
            ItemId : this.ItemId,
            AvailableQuantity: null,
            IssuedQuantity: null,
            MFGDate: null,
            ExpiryDate: null,
          },
        ],
      },
    };
  },
  methods: {
    addNewBatchRow: function (itemId) {
      this.data.batches.push({
        Id: null,
        ItemId : itemId,
        AvailableQuantity: null,
        IssuedQuantity: null,
        MFGDate: null,
        ExpiryDate: null,
      });

      this.data.batches = this.checkUniqueBatches(this.data.batches, "Id");
    },
    removeRow: function (row) {
      this.data.batches.splice(row, 1);
    },
    checkUniqueBatches: function (arr, key) {
      var uniqueBatches = [
        ...new Map(arr.map((item) => [item[key], item])).values(),
      ];
      return uniqueBatches;
    },
    getItemBatchDetail() {
      /* axios
        .get("waybill/item/" + this.ItemId)
        .then((response) => {
          console.log(response.data);
        })
        .catch((error) => {
          this.errored = true;
        })
        .finally(() => (this.loading = false)); */
    },
    getSingleBatchDetail(batchId, batch) {
      axios
        .get("waybill/item/batch/" + batchId)
        .then((response) => {
          batch.AvailableQuantity = response.data.data.AvailableQuantity;
          batch.ExpiryDate = response.data.data.ExpiryDate;
        })
        .catch((error) => {
          this.errored = true;
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-add-new-batch {
  // position: absolute;
  // right: 135px;
}
</style>
